import { render, staticRenderFns } from "./product-group-stock.vue?vue&type=template&id=573674ae"
import script from "./product-group-stock.vue?vue&type=script&lang=js"
export * from "./product-group-stock.vue?vue&type=script&lang=js"
import style0 from "./product-group-stock.vue?vue&type=style&index=0&id=573674ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports